import { render, staticRenderFns } from "./magazine-content.vue?vue&type=template&id=a4279bde&scoped=true"
import script from "./magazine-content.vue?vue&type=script&lang=js"
export * from "./magazine-content.vue?vue&type=script&lang=js"
import style0 from "./magazine-content.vue?vue&type=style&index=0&id=a4279bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4279bde",
  null
  
)

export default component.exports